import { entity } from '@talisdev/jsonapi-transformers';

import { HierarchyNode } from './hierarchy-node';

@entity({ type: 'departments' })
export class Department extends HierarchyNode {}
